import React from 'react';

import getDisplayDBType from '../../../../utils/getDisplayDBType';
import styles from './styles/detail-box.module.css';

import BoxStatus from '../../../design-system/box/BoxStatus';
import ButtonRadius5 from '../../../design-system/button/ButtonRadius5';
import {ReactComponent as X02Icon} from '../../../../assets/design-system/x-02-width-2.svg';

export default function DetailBox({ selectedItem, closeSidebar, getConnectionStatus, getBoxStatusInfo, getButtonInfo }) {
    const { id, aliasName, dbType, state, owner, editor, connectAt, createdAt, updatedAt } = selectedItem;

    const currentConnectionStatus = getConnectionStatus(id);

    const infoMap = [
        { label: '별칭', value: aliasName || '-' },
        { label: 'DB 타입', value: <>{getDisplayDBType(dbType)}</> },
        { 
            label: '연결 상태', 
            value:
                <BoxStatus
                    status={getBoxStatusInfo(currentConnectionStatus, state).status}
                    icon={getBoxStatusInfo(currentConnectionStatus, state).icon}
                    text={getBoxStatusInfo(currentConnectionStatus, state).text}
                />
        },
        { label: '최근 연결 날짜', value: connectAt || '-' },
        { label: '담당자', value: owner || '-' },
        { label: '최근 수정자', value: editor || '-' },
        { label: '생성일', value: createdAt ||  '-' },
        { label: '수정일', value: updatedAt || '-' }
    ];

    return (
        <div className={styles.wrapper}>
            <div className={styles.boxHeader}>
                <p>DB 상세정보</p>
                <X02Icon className={styles.icon} onClick={closeSidebar} />
            </div>
            <div className={styles.boxInfo}>
                {infoMap.map(({ label, value }) => (
                    <div key={label} className={styles.info}>
                        <p className={styles.label}>{label}</p>
                        <div className={styles.value}>{value}</div>
                    </div>
                ))}
            </div>
            <div className={styles.separator} />
            <div className={styles.boxBottom}>
                <ButtonRadius5
                    width='100%'
                    height='H40'
                    status={getButtonInfo(currentConnectionStatus, id).status}
                    text={getButtonInfo(currentConnectionStatus, id).text}
                    handleClick={getButtonInfo(currentConnectionStatus, id).handleClick}
                />
                <p className={styles.comment}>데이터베이스 연결 상태를 실시간으로 확인하세요</p>
            </div>
        </div>
    );
}
